import React from 'react';
import { painPoints } from '../data/painPoints';
export function PainSection() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-141" data-mp="38yggibtmasnx">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-142" data-mp="38x5cqc069kwt">
        <h2 className="text-center text-2xl leading-none text-white sm:text-4xl" data-id="element-143" data-mp="2uyoxfwo8um32">
          DOES THIS SOUND <span className="text-gold" data-id="element-144" data-mp="2yz7m5huubc11">FAMILIAR?</span>
        </h2>
        <p className="mx-auto mt-2 max-w-3xl text-center text-sm leading-snug text-white/85 sm:text-base" data-id="element-145" data-mp="2z1lkbzkth4ct">
          You're studying aircraft systems, cockpit instruments, aerodynamics, navigation, and
          flight procedures—but aviation textbooks are packed with technical explanations that
          can be difficult to visualize, connect, and remember.
        </p>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-146" data-mp="2g9ixg6hl0ru4">
          {painPoints.map(point => <article key={point.title} className="rounded-xl border-l-4 border-gold bg-navy-deep p-3 sm:p-4" data-id="element-147" data-mp="22bkxi640cxy5">
              <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-148" data-mp="3rm97t0oci8tk">{point.title}</h3>
              <p className="mt-1 text-sm leading-snug text-white/80" data-id="element-149" data-mp="3nlyvl69ymm69">{point.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}